import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Severity } from 'app/shared/enums/severity';
import { of as observableOf, throwError as observableThrowError } from 'rxjs';
import { CONFIG } from './config';
import { ApiResult } from './messages/api-result';


export abstract class BackendServiceBase {
  protected headers: HttpHeaders = this.getHeaders();
  protected options = {
    headers: this.headers,
    params: new HttpParams(),
  };

  protected apiUrl: string;
  protected identityUrl: string;

  /**
   * Provides a generic means of handling errors returned from the API.
   * @param message The message returned from the API.
   * @param error An object containing further details of the error.
   */
  protected handleError(message: string, error: any) {
    if (error.status === 401) {
      const currentPath = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : window.location.hash;

      window.location.href = `${window.location.origin + CONFIG.routes.authLogin}?landingpage=${currentPath}`;

    }

    const errMsg = error
      ? error.error
        ? error.error
        : JSON.stringify(error)
      : error.statusText || 'unknown error';

    console.error(message, errMsg);

    try {
      let errorDetails = error.error;

      const result: ApiResult = new ApiResult();

      if (!errorDetails.messages) {
        errorDetails = {
          success: error.error.isSuccessStatusCode,
          severity: Severity.Error,
          messages: [{ text: error.error.reasonPhrase, severity: Severity.Error }],
        };
      }

      result.loadFromJson(errorDetails);

      return observableThrowError(result);
    } catch (caughtError) {
      return observableOf(false);
    }

  }

  /**
   * Generates the required request headers to make an authenticated request to
   * the backend API.
   * @param getToken A function which provides the authorization token.
   */
  protected getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    });
  }

  /**
   * Generates query parameter key:value pairs from every property of the request object
   * @param request any object providing key:value pairs for the query parameters
   */
  public createHttpParams(request: any): HttpParams {
    let params: HttpParams = new HttpParams();

    for (const key in request) {
      if (request.hasOwnProperty(key)
        && key !== 'friendlyTypeNameSingular'
        && key !== 'apiRoute') {
        // params is immutable so we must reassign the variable each time
        params = params.set(key, request[key]);
      }
    }

    return params;
  }
}
